import { render } from "./AccountSelector.vue?vue&type=template&id=1aef3efd&scoped=true&ts=true"
import script from "./AccountSelector.vue?vue&type=script&lang=ts"
export * from "./AccountSelector.vue?vue&type=script&lang=ts"

import "./AccountSelector.vue?vue&type=style&index=0&id=1aef3efd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aef3efd"]])

export default __exports__